/* fb-commerce.js — Empire-independent quick-add + in-card quantity stepper.

   Owns the card "agregar a carrito" button. The theme renders `[data-quick-buy]`
   ONLY for single-variant products (see snippets/product-grid-item.liquid: it emits
   data-quick-buy when `unless has_variants`, else data-quickshop-slim), so the variant
   id sits right on the button in `data-variant-id` — no form, no variant picker needed.

   Flow: click "Agregar" → POST /cart/add.js → the button is replaced in place by a
   [ − N + ] stepper that reflects the cart quantity for that variant. − decrements
   (0 removes the line and reverts to the button), + increments. Steppers are hydrated
   from /cart.js on load, so a product already in the cart shows its stepper immediately.

   There is NO side cart here — adding does not open any drawer. The header cart bubble
   updates on its own: fb-chrome.js wraps window.fetch and refreshes the count after any
   /cart/(add|change|update|clear) request, which our requests trigger.

   Rebuy removed: we used to nudge window.Rebuy.SmartCart.show() open on add — gone.

   Double-add safety: we bind on document in the CAPTURE phase and call
   stopImmediatePropagation on quick-buy clicks, so even if Empire later loads and binds
   its own delegated click handler, it never fires for these buttons. Multi-variant
   quick-shop is a separate, later step and is intentionally left to Empire for now. */
(function () {
  'use strict';

  var BUY_SEL = '[data-quick-buy]';
  var MINUS_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="2.5" y="7.1" width="11" height="1.8" rx=".9" fill="currentColor"/></svg>';
  var PLUS_SVG  = '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="2.5" y="7.1" width="11" height="1.8" rx=".9" fill="currentColor"/><rect x="7.1" y="2.5" width="1.8" height="11" rx=".9" fill="currentColor"/></svg>';

  // variantId (string) -> quantity in cart
  var qtyMap = Object.create(null);

  function root() {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/+$/, '/');
  }
  function postJSON(path, body) {
    return window.fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (e) { throw e; }, function () { throw res; });
      return res.json();
    });
  }
  function getCart() {
    return window.fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /* ---- cart state ---- */
  function ingestCart(cart) {
    qtyMap = Object.create(null);
    if (cart && cart.items) {
      cart.items.forEach(function (it) { qtyMap[String(it.id)] = it.quantity; });
    }
  }
  function announce(cart) {
    // Un solo evento, con el carrito a bordo: quien escuche (cajón, burbuja del header,
    // ficha) pinta de aquí en vez de volver a pedir /cart.js. Antes salían dos eventos
    // (cart:updated + cart:refresh) y cada oyente leía el carrito por cada uno.
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
  }

  /* ---- stepper DOM ---- */
  function ensureStepper(btn) {
    var wrap = btn.parentNode; // .atc--button
    if (!wrap) return null;
    var stp = wrap.querySelector('[data-fb-qty]');
    if (stp) return stp;
    stp = document.createElement('div');
    stp.className = 'fb-qty';
    stp.setAttribute('data-fb-qty', '');
    stp.hidden = true;
    stp.innerHTML =
      '<button type="button" class="fb-qty__btn" data-fb-qty-dec aria-label="Quitar uno">' + MINUS_SVG + '</button>' +
      '<span class="fb-qty__count" data-fb-qty-count aria-live="polite">0</span>' +
      '<button type="button" class="fb-qty__btn" data-fb-qty-inc aria-label="Agregar uno">' + PLUS_SVG + '</button>';
    wrap.appendChild(stp);
    return stp;
  }

  function paint(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var qty = qtyMap[String(variantId)] || 0;
    var stp = ensureStepper(btn);
    if (!stp) return;
    if (qty > 0) {
      var count = stp.querySelector('[data-fb-qty-count]');
      if (count && count.textContent !== String(qty)) {
        count.textContent = String(qty);
        count.classList.remove('is-bumped'); void count.offsetWidth; count.classList.add('is-bumped');
      } else if (count) {
        count.textContent = String(qty);
      }
      // `visibility` y no `display`: el botón tiene que seguir ocupando su lugar
      // para que el stepper —superpuesto -- herede su altura exacta (ver
      // fb-commerce.css). Con `display:none` la caja se colapsaba y el stepper
      // caía en su propia altura mínima, más alta que el botón.
      // Sigue siendo estilo en línea porque así le gana a `.button-primary`,
      // igual que antes. `visibility:hidden` también lo saca del orden de
      // tabulación y de los lectores de pantalla, así que no queda un control
      // fantasma debajo.
      btn.style.visibility = 'hidden';
      stp.hidden = false;
    } else {
      btn.style.visibility = '';
      stp.hidden = true;
    }
  }

  // repaint every quick-buy button that shares this variant (a product can appear in
  // more than one grid on the same page), plus reset any button no longer in cart.
  function paintAll() {
    Array.prototype.forEach.call(document.querySelectorAll(BUY_SEL), paint);
  }

  function setBusy(stp, on) {
    if (!stp) return;
    stp.classList.toggle('is-busy', !!on);
  }

  /* ---- fly-to-cart: a 240px copy of the cover photo shrinks toward the header cart;
     on arrival fb-chrome lands the bubble number + wiggle + "+N" (window.fbCart). ---- */
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function to240(url) {
    if (!url) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1240');
    if (/_\d+x\d*(\.(?:jpg|jpeg|png|webp|gif))/i.test(url)) return url.replace(/_\d+x\d*(\.(?:jpg|jpeg|png|webp|gif))/i, '_240x240$1');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  }
  function cardImageFrom(el) {
    var card = el && el.closest ? el.closest('[data-product-item-content], .productitem, .fb-rec-card') : null;
    return card ? card.querySelector('img') : null;
  }
  // Resolve a usable, ALREADY-LOADED src: prefer the 240 thumbnail, but fall back to the
  // card's current src (guaranteed loaded) so the clone never flies as an empty box.
  function preloadImage(url, fallback) {
    return new Promise(function (resolve) {
      if (!url) { resolve(fallback); return; }
      var img = new Image(), settled = false;
      function use(src) { if (settled) return; settled = true; resolve(src); }
      img.onload = function () { use(url); };
      img.onerror = function () { use(fallback || url); };
      img.src = url;
      if (img.complete && img.naturalWidth) use(url);                 // already cached
      window.setTimeout(function () { use(fallback || url); }, 700);  // don't block too long
    });
  }
  function flyToCart(srcImg, imgSrc, onArrive, startRect, onLiftoff) {
    var liftoff = onLiftoff || function () {};
    var cart = document.querySelector('.site-header-cart--button');
    if (REDUCED || (!srcImg && !startRect) || !cart || !imgSrc) { liftoff(); onArrive(); return; }
    // startRect: caller-captured rect, for sources that leave the DOM before the flight
    // starts (e.g. the PDP rec card fades out as soon as it's added).
    var s = startRect || srcImg.getBoundingClientRect();
    var c = cart.getBoundingClientRect();
    if (!s.width || !c.width) { liftoff(); onArrive(); return; }
    var clone = document.createElement('img');
    clone.className = 'fb-fly';
    clone.setAttribute('aria-hidden', 'true');
    clone.src = imgSrc;                                  // preloaded → renders immediately
    clone.style.left = s.left + 'px';
    clone.style.top = s.top + 'px';
    clone.style.width = s.width + 'px';
    clone.style.height = s.height + 'px';
    document.body.appendChild(clone);
    var tx = (c.left + c.width / 2) - (s.left + s.width / 2);
    var ty = (c.top + c.height / 2) - (s.top + s.height / 2);
    void clone.offsetWidth; // reflow so the transition runs from the start rect
    clone.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(.12)';
    clone.style.opacity = '0'; // stays full until the delayed transition fades it near the end
    liftoff(); // the clone is visibly in flight — callers can now hide/remove the source
    var done = false;
    function finish() {
      if (done) return; done = true;
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      onArrive();
    }
    clone.addEventListener('transitionend', finish, { once: true });
    window.setTimeout(finish, 1350); // fallback if transitionend never fires
  }
  // 1) slide the header DOWN + preload the thumbnail (in parallel), 2) once BOTH are ready
  // fly the image to the cart, 3) release (bubble number + "+N" + wiggle) on arrival.
  function addWithFly(srcImg, mutatePromise, startRect, onLiftoff) {
    if (window.fbCart) window.fbCart.hold();
    var wasHidden = window.fbCart && window.fbCart.reveal ? window.fbCart.reveal() : false;
    var loaded = srcImg ? (srcImg.currentSrc || srcImg.src) : null;
    var preload = preloadImage(srcImg ? to240(loaded) : null, loaded);
    var settle = new Promise(function (res) { window.setTimeout(res, wasHidden ? 380 : 0); });
    Promise.all([preload, settle]).then(function (r) {
      flyToCart(srcImg, r[0], function () {
        mutatePromise.then(
          function (delta) { if (window.fbCart) window.fbCart.release(typeof delta === 'number' ? delta : 1); },
          function () { if (window.fbCart) window.fbCart.release(0); }
        );
      }, startRect, onLiftoff);
    });
  }
  // shared with other scripts (fb-product.js flies the PDP rec-card thumbnail)
  window.fbFly = addWithFly;

  /* ---- mutations ---- */
  function addOne(variantId) {
    return postJSON('cart/add.js', { items: [{ id: Number(variantId) || variantId, quantity: 1 }] })
      .then(function () { return getCart(); })
      .then(function (cart) { ingestCart(cart); paintAll(); announce(cart); });
  }
  function changeTo(variantId, quantity) {
    return postJSON('cart/change.js', { id: String(variantId), quantity: quantity })
      .then(function (cart) { ingestCart(cart); paintAll(); announce(cart); });
  }

  /* ---- events ---- */
  // "Agregar" — capture phase so Empire never double-adds.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(BUY_SEL) : null;
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return; // malformed — don't claim it
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.hasAttribute('disabled') || btn.classList.contains('processing')) return;

    btn.classList.add('processing');           // theme.css spinner state
    btn.setAttribute('aria-busy', 'true');
    var p = addOne(variantId);
    addWithFly(cardImageFrom(btn), p);
    p.catch(function () { btn.classList.add('atc--error'); setTimeout(function () { btn.classList.remove('atc--error'); }, 1500); })
     .then(function () { btn.classList.remove('processing'); btn.removeAttribute('aria-busy'); });
  }, true);

  // stepper +/− — normal bubbling phase.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-fb-qty-inc],[data-fb-qty-dec]') : null;
    if (!t) return;
    var stp = t.closest('[data-fb-qty]');
    var wrap = stp && stp.parentNode;
    var btn = wrap && wrap.querySelector(BUY_SEL);
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    e.preventDefault();
    if (stp.classList.contains('is-busy')) return;

    var current = qtyMap[String(variantId)] || 0;
    var isInc = t.hasAttribute('data-fb-qty-inc');
    var next = current + (isInc ? 1 : -1);
    if (next < 0) next = 0;

    setBusy(stp, true);
    var p = changeTo(variantId, next);
    if (isInc) addWithFly(cardImageFrom(stp), p); // + also flies a copy to the cart
    p.catch(function () { /* leave state as-is; paintAll already reflects server on success */ })
     .then(function () { setBusy(stp, false); });
  });

  /* ---- product detail page: take over the product form (de-Empire). Clicking
     "Añadir al carrito" does our own AJAX /cart/add.js, then flies the gallery image
     to the cart with the chosen quantity. Works regardless of Empire/Rebuy state. ---- */
  function sourceImageForForm(form) {
    var c = form.closest('.product, [data-product-item-content], .productitem, [data-quickshop], .product-gallery-wrapper, main, body');
    var img = c && (c.querySelector('.product-gallery__viewer .swiper-slide-active img')
                 || c.querySelector('.product-gallery__viewer img')
                 || c.querySelector('.product-gallery-wrapper img')
                 || c.querySelector('img'));
    return img || document.querySelector('.product-gallery__viewer img, .product-gallery-wrapper img');
  }
  function pdpQuantity(form) {
    var q = (form && form.querySelector('input[name="quantity"]'))
         || document.querySelector('[data-product-form] input[name="quantity"]');
    return q ? (parseInt(q.value, 10) || 1) : 1;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.product-form--atc-button, button[name="add"]') : null;
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]') || btn.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();          // preempt Empire's handler + the native POST
    if (btn.hasAttribute('disabled') || btn.classList.contains('processing')) return;
    // Modo carrito (fb-product.js): el input ya no dice "cuántos voy a agregar" sino
    // cuántos HAY en el carrito, y /cart/add.js suma. Agregar aquí duplicaba la línea.
    // En escritorio el botón está oculto en ese modo; esto cubre cualquier otro camino.
    var cajaQty = form.querySelector('.product-form--atc');
    if (cajaQty && cajaQty.getAttribute('data-fb-qty-mode') === 'cart') {
      if (window.fbCartDrawer && window.fbCartDrawer.open) window.fbCartDrawer.open();
      else window.location.href = '/cart';
      return;
    }

    btn.classList.add('processing');
    btn.setAttribute('aria-busy', 'true');
    var qty = pdpQuantity(form);
    var img = sourceImageForForm(form);
    var addP = window.fetch('/cart/add.js', {
      method: 'POST', body: new FormData(form),
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (er) { throw er; }, function () { throw r; }); return r.json(); })
      .then(function () { return getCart(); })
      .then(function (cart) { ingestCart(cart); paintAll(); announce(cart); return qty; });
    addWithFly(img, addP);
    addP.catch(function () { btn.classList.add('atc--error'); setTimeout(function () { btn.classList.remove('atc--error'); }, 1500); })
        .then(function () { btn.classList.remove('processing'); btn.removeAttribute('aria-busy'); });
  }, true);

  /* ---- hydrate on load ---- */
  function hydrate() { getCart().then(function (cart) { ingestCart(cart); paintAll(); }).catch(function () {}); }
  // for scripts that inject quick-buy buttons after load (fb-product.js PDP rec cards)
  window.fbQuickBuy = { refresh: hydrate };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
